import React, { Fragment } from 'react';
import * as constants from 'common/constants';
import { base64url_encode } from 'util/base64';
import {
  Button,
  CardList,
  IconList,
  Modal,
  Offline,
  ProgressBar,
  BannerComponent,
  LevelNav,
  Dropdown,
  NetworkStatus,
} from 'common/components';
import { uniqBy } from 'common/utils';
import PropTypes from 'prop-types';
import { offline as OfflineIcon } from 'common/svg/icons';
import { withApollo } from 'react-apollo';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FETCH_STORAGE_WITH_ALL_ACTIVITIES } from 'api/storage';

class StorageList extends React.Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
    season: PropTypes.number.isRequired,
    storages: PropTypes.array,
  };

  state = {
    showUnavailableModal: false,
    filterBy: { field: '', value: 'ALL' },
  };

  hideUnavailableModal = () => {
    this.setState({
      showUnavailableModal: false,
    });
  };

  showUnavailableModal = () => {
    this.setState({
      showUnavailableModal: true,
    });
  };

  _getContent = storage => {
    const { crop, contentValue } = storage;
    const { size, used, type } = storage.capacity;
    const list = [];

    crop &&
      list.push({
        icon: 'crop',
        label: `${crop.name} ${crop.variety ? crop.variety : ''}`,
      });

    !!Number(contentValue) &&
      list.push({
        icon: 'dollar',
        label: contentValue.value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      });

    return (
      <Fragment>
        <IconList list={list} />
        <ProgressBar value={used} max={size} unit={type && type.slice(0, 2)} />
        {this.state.showUnavailableModal && (
          <Modal
            header={'Unavailable offline'}
            theme={['narrow']}
            onToggle={this.hideUnavailableModal}
          >
            <p>You must be connected to the internet to view this storage.</p>
            <section className={'field__group'}>
              <fieldset className={'field text--center'}>
                <Button
                  className="btn btn--primary"
                  onClick={this.hideUnavailableModal}
                >
                  OK
                </Button>
              </fieldset>
            </section>
          </Modal>
        )}
      </Fragment>
    );
  };

  _getCardData = storage => {
    const { client, season } = this.props;

    let availableOffline = false;
    try {
      const sourceName = storage.id.split(':')[1];
      client.readQuery({
        query: FETCH_STORAGE_WITH_ALL_ACTIVITIES,
        variables: { id: storage.id, sourceName, season },
      });
      availableOffline = true;
    } catch (error) {
      // Apollo throws an error if no data is found
    }

    return {
      availableOffline,
      handleUnavailableClick: this.showUnavailableModal,
      title: storage.name,
      content: this._getContent(storage),
      link: `${constants.ROUTE_STORAGE_DETAIL}/${base64url_encode(
        storage.id.trim()
      )}`,
    };
  };

  _getCardsArray = data => data.map(storage => this._getCardData(storage));

  _setFilter(filterBy) {
    this.setState({ filterBy });
  }

  _getActivityTypeFilter = () => {
    const {
      filterBy: { value },
    } = this.state;
    const { storages } = this.props;
    const binYardOptions = uniqBy(storages, 'binYard')
      .map(stg => ({
        label: stg.binYard,
        filterBy: { field: 'binYard', value: stg.binYard },
      }))
      .filter(
        binYard => !!binYard.label && binYard.label.toLowerCase() !== 'none'
      );

    const list = [
      { label: 'ALL', filterBy: { field: '', value: 'ALL' } },
      ...binYardOptions,
    ].filter(({ label }) => label !== value);

    return (
      <Dropdown
        hideOnSelect
        trigger={<span>{value.toUpperCase()}</span>}
        theme={['right', 'select']}
      >
        <ul>
          {list.map(
            option =>
              option.label && (
                <li
                  className="cursor--pointer"
                  key={option.label}
                  onClick={() => this._setFilter(option.filterBy)}
                >
                  {option.label}
                </li>
              )
          )}
        </ul>
      </Dropdown>
    );
  };

  _renderFilters = () => {
    const theme = ['strong', 'sticky'];
    return (
      <BannerComponent theme={theme}>
        <LevelNav
          theme={['sticky']}
          nav={{
            right: {
              element: this._getActivityTypeFilter(),
            },
          }}
        />
      </BannerComponent>
    );
  };

  render() {
    const { storages = [] } = this.props;
    const {
      filterBy: { field, value },
    } = this.state;

    const filteredStorages = storages.filter(item => {
      if (!field || !value) return true;
      return item[field] === value;
    });

    return (
      <Fragment>
        {this._renderFilters()}
        <Offline>
          <BannerComponent
            message="Some storages may not be available in offline mode."
            theme={['offline-short']}
            leftIcon={<OfflineIcon />}
          />
        </Offline>
        <NetworkStatus
          render={({ isOnline }) => (
            <CardList
              cards={this._getCardsArray(filteredStorages)}
              emptyStateconfig={{
                message:
                  'Add storage to track filled vs free capacity across your bins and see storage summary on the dashboard.',
                btnMessage: 'Add Storage',
                routeName: constants.ROUTE_STORAGE_ADD,
                showAdd: isOnline,
              }}
            />
          )}
        />
      </Fragment>
    );
  }
}

const mapState = ({ settings }) => ({ season: settings.season });

export { StorageList };

export default compose(
  connect(mapState),
  withApollo
)(StorageList);



// WEBPACK FOOTER //
// ./src/containers/StorageList/index.js